<div class="card-body pb-0" #contentToConvert>
  <div class="receipt">
    <!-- Show loading spinner while fetching data -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p>Fetching payment details...</p>
    </div>

    <!-- Show receipt content when data is loaded -->
    <div *ngIf="!isLoading">
      <div class="row">
        <div class="col-sm-12">
          <img src="../../assets/img/logo-light.png" class="header-brand-img reciptLogo desktop-logo" alt="logo">
          <h6 class="mra">{{InstuName}}</h6>
          <h6 class="mra1">Third Party Payment Receipt - VOD</h6>
        </div>
      </div>

      <div class="row">
        <div class="receipt-details">
          <div class="row">
            <div class="col-sm-6">
              <p><strong>Receipt Number:</strong> {{reciptNumber}}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Date:</strong> {{currentDate | date: 'dd/MM/yyyy'}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <p><strong>College:</strong> {{clgName || 'N/A'}} <span id="college"></span></p>
            </div>
            <div class="col-sm-6">
              <p><strong>Course:</strong> {{CoName || 'N/A'}} <span id="program"></span></p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6" *ngIf="PreFix != ''">
              <p><strong>Rg No/PRN No.:</strong> {{PreFix}}/{{formattedPrn || RgNo}}</p>
            </div>
            <div class="col-sm-6" *ngIf="PreFix == ''">
              <p><strong>Rg No/PRN No.:</strong> {{formattedPrn || RgNo}}</p>
            </div>
            <div class="col-sm-6" *ngIf="StuName">
              <p><strong>Name:</strong> {{StuName}}</p>
            </div>
            <div class="col-sm-6" *ngIf="!StuName">
              <p><strong>Name:</strong> {{FirstName}} {{MiddleName}} {{LastName}}</p>
            </div>
          </div>

          <!-- Organization Details -->
          <div class="row" *ngIf="data.OrgId">
            <div class="col-sm-6">
              <p><strong>Organization ID:</strong> {{data.OrgId}}</p>
            </div>
            <div class="col-sm-6">
              <p><strong>Fee Type:</strong> {{data.FeeType || 'VOD'}}</p>
            </div>
          </div>

          <!-- Transaction Details -->
          <div class="row" *ngIf="data.TxnNumber">
            <div class="col-sm-6" *ngIf="data.PaymentSource">
              <p><strong>Payment Source:</strong> {{data.PaymentSource}}</p>
            </div>
          </div>

          <div class="row" *ngIf="data.ApplicationModule">
            <div class="col-sm-6">
              <p><strong>Application Module:</strong> {{data.ApplicationModule}}</p>
            </div>
            <div class="col-sm-6" *ngIf="data.ResponseCode">
              <p><strong>Response Code:</strong> {{data.ResponseCode}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- VOD Fee Table -->
      <div class="mt-2" *ngIf="payHistoryData && payHistoryData.length > 0">
        <table class="styled-table" style="width:100%">
          <thead>
            <tr>
              <th width="40%" class="f600" style="text-align: left !important;">Fee Head</th>
              <th width="20%" class="f600" style="text-align: right !important;">Fee Paid</th>
              <th width="20%" class="f600" style="text-align: right !important;">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payHistoryData; let i = index">
              <td style="text-align: left !important;">{{item.FeeHead}}</td>
              <td style="text-align: right !important;" *ngIf="Currency == 'INR'">
                <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
              </td>
              <td style="text-align: right !important;" *ngIf="Currency == 'USD'">
                <span class="currency-symbol Textmrg1">$ {{item.FeeAmt}}</span>
              </td>
              <td style="text-align: right !important;">{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- VOD Details -->
      <div class="mt-2" *ngIf="data.DeliveryOpt">
        <ul>
          <li><strong>Verification of University Document </strong></li>
          <li><strong>Delivery Option:</strong> {{data.DeliveryOpt == 'Hard' ? 'Hard Copy' : (data.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
        </ul>
        <ul>
          <li><strong>Fee Details:</strong></li>
          <li>Base Amount: ₹3050</li>
          <li>Copies Fee: Not Applicable</li>
          <li *ngIf="data.DeliveryOpt == 'Soft' || data.DeliveryOpt == 'Both'">Soft Copy Delivery Fee: ₹800</li>
          <li *ngIf="data.DeliveryOpt == 'Hard' || data.DeliveryOpt == 'Both'">Hard Copy Delivery Fee: ₹2570</li>
        </ul>
      </div>

      <!-- Total Amount -->
      <div class="row">
        <div class="receipt-footer">
          <div class="row mt-1">
            <div class="col-sm-6" *ngIf="Currency == 'INR'">
              <b>Total Paid Amount :</b>
              <span class="currency-symbol Textmrg1">&#8377;{{TotalPaidAmount || 0}}</span>
            </div>
            <div class="col-sm-6" *ngIf="Currency == 'USD'">
              <b>Total Paid Amount :</b>
              <span class="currency-symbol Textmrg1">$ {{TotalPaidAmount || 0}}</span>
            </div>
            <div class="col-sm-6">
              <p><strong>Payment Mode:</strong> {{payModeee || 'N/A'}}</p>
            </div>
          </div>

          <div class="row" *ngIf="TotalPaidAmountInWords">
            <div class="col-sm-12" *ngIf="Currency == 'INR'">
              <b>In Words :</b>
              <span class="currency-symbol linkk Textmrg1">Rupees {{TotalPaidAmountInWords}} Only</span>
            </div>
            <div class="col-sm-12" *ngIf="Currency == 'USD'">
              <b>In Words :</b>
              <span class="currency-symbol linkk Textmrg1">Dollars {{TotalPaidAmountInWords}} Only</span>
            </div>
          </div>

          <!-- Status -->
          <div class="row mt-2">
            <div class="col-sm-12">
              <p><strong>Payment Status:</strong> 
                <span class="status-badge" [ngClass]="{
                  'status-success': data.Status === 'SUCCESS' || data.Status === 'Success',
                  'status-failed': data.Status === 'FAILED' || data.Status === 'Failed',
                  'status-pending': data.Status === 'PENDING' || data.Status === 'Pending'
                }">
                  {{data.Status || 'N/A'}}
                </span>
              </p>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div class="row col-sm-12 mb-2 mt-2">
    <div class="col-sm-2 divName offset-8">
      <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="close()">
        <span style="display: contents; align-items: center;">
          Close
        </span>
      </button>
    </div>
    <div class="col-sm-2 divName">
      <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="downloadAsPDF()" [disabled]="generatingPDF || isLoading">
        <span style="display: contents; align-items: center;">
          {{ generatingPDF ? 'Generating...' : 'Download' }}
        </span>
      </button>
    </div>
  </div>
</div>